// extracted by mini-css-extract-plugin
module.exports = {"loomBadgeWrapper":"loom-badge_loomBadgeWrapper_3JQ","loomBadgeText":"loom-badge_loomBadgeText_3MN","loomBadgeLogo":"loom-badge_loomBadgeLogo_1c8"};